var SELF_TARGET = '_self';
export { SELF_TARGET };